var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",on:{"click":function($event){return _vm.hideSlideMenu($event)}}},[_c('AppHeader'),_c('div',{staticClass:"container"},[_c('router-view'),_c('AppFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }